import axios from "axios";
import DownloadIcon from "imagesUwKluis/svg/download.svg";
import { useMemo } from "react";
import { useQuery } from "react-query";
import { useLocation } from "react-router-dom";
import Card from "../../shared/Card";
import Header from "../../shared/Header";
import { Stack } from "../../shared/layouts";
import Loader from "../../shared/Loader";
import {useTranslation} from "react-i18next";
import FilesTable from "./FilesTable";
import useIconLibrary from "../../../hooks/useIconLibrary";

const PersonalDocumentsPage = () => {
  const { state } = useLocation();
  const { newDocumentId } = state || {};

  const { t } = useTranslation();

  const { isLoading, isError, data: apiData = {} } = useQuery(
    "documentsReceived",
    async () => await axios("/files/organization-files")
  );

  const data = useMemo(
    () =>
      apiData.data?.files?.map(
        ({ created_at: date, original_filename: name, files_id: fileId, description }) => ({
          date,
          description,
          name,
          highlighted: newDocumentId === fileId,
          download: (
            <a href={`/files/organization-files/${fileId}`} download>
              <DownloadIcon
                width="1.5rem"
                height="1.5rem"
                css={(theme) => ({ fill: theme?.colors?.primary })}
              />
            </a>
          ),
        })
      ),
    [apiData.data, newDocumentId]
  );

  const { DocumentsIcon } = useIconLibrary();

  return (
    <>
      {isLoading && <Loader />}
      <Stack space="xl" width={{ sm: 656, ml: 672, lg: 800, xl: 1024 }}>
        <Header
          title={t("Mijn documenten")}
          icon={<DocumentsIcon height="2rem" width="2rem" />}
          variant="page"
        />
        <Card>
          <Stack space="l">
            <FilesTable data={data} isError={isError} />
          </Stack>
        </Card>
      </Stack>
    </>
  );
};

export default PersonalDocumentsPage;
